"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPolicyDefinitionList = exports.PolicyDefinitionList = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = __importDefault(require("react"));
var stringifyLinesOfCoverage_1 = require("../../utils/stringifyLinesOfCoverage");
function PolicyDefinitionList(props) {
    var policy = props.policy, hideTitle = props.hideTitle, onAccountClick = props.onAccountClick, accountHref = props.accountHref;
    return (react_1.default.createElement(core_ui_1.DefinitionList, { hideTitle: hideTitle, items: createPolicyDefinitionList({
            policy: policy,
            onAccountClick: onAccountClick,
            accountHref: accountHref,
        }), labelWidth: "150px" }));
}
exports.PolicyDefinitionList = PolicyDefinitionList;
function createPolicyDefinitionList(props) {
    var policy = props.policy, accountHref = props.accountHref, onAccountClick = props.onAccountClick;
    var account = policy.account, expirationDate = policy.expirationDate, linesOfCoverage = policy.linesOfCoverage, effectiveDate = policy.effectiveDate, policyNumber = policy.policyNumber, carrier = policy.carrier;
    var items = [];
    if (account) {
        items.push({
            type: 'name',
            title: 'Client',
            value: (account === null || account === void 0 ? void 0 : account.name) || '-',
            href: accountHref,
            onClick: onAccountClick,
        });
    }
    items = __spreadArray(__spreadArray([], items), [
        {
            type: 'document',
            title: 'Line of coverage',
            value: stringifyLinesOfCoverage_1.stringifyLinesOfCoverage(linesOfCoverage),
        },
        {
            type: 'dateRange',
            title: 'Effective dates',
            value: string_formatters_1.CalendarDate.fromDate(effectiveDate, 'UTC') + " - " + string_formatters_1.CalendarDate.fromDate(expirationDate, 'UTC'),
        },
        {
            type: 'business',
            title: 'Carrier',
            value: (carrier === null || carrier === void 0 ? void 0 : carrier.name) || '-',
        },
    ]);
    if (policyNumber) {
        items.push({
            type: 'number',
            title: 'Policy number',
            value: policyNumber,
            target: '_blank',
        });
    }
    return items;
}
exports.createPolicyDefinitionList = createPolicyDefinitionList;
